/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleHistoryManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './moduleHistoryManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_DEPOSIT (state, deposit) {
      state.deposit = deposit
    },
    SET_WITHDRAW (state, withdraw) {
      state.withdraw = withdraw
    },
    SET_POPUP (state, popup) {
      state.popup = popup;
    },
    SET_SELECTED (state, selected) {
      state.selected = selected;
    },
    SET_POPUP2 (state, popup) {
      state.popup2 = popup;
    },
     SET_POPUP4 (state, popup) {
      state.popup4 = popup;
    },
    SET_FIELD(state, field) {
      state.field = field;
    },
    SET_SLIP (state, deposit) {
      state.slip = deposit
    },
    SET_INDEX (state, index) {
      state.index = index
    },
    SET_ITEMS (state,items) {
      state.items = items
    },
    SET_USERID (state, selected) {
      state.userId = selected;
    },
    SET_SLIP_SELECTED (state, selected){
      state.slip_selected = selected;
    },
    SET_CREDIT (state,credit){
      state.credit = credit
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
}

